var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step2" }, [
    _c("div", { staticClass: "content" }, [
      _c("label", { staticClass: "header" }, [_vm._v("Personal Information")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form" },
        [
          _c("fieldset", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.patient.firstName,
                  expression: "patient.firstName",
                },
              ],
              class: { error: !_vm.validate.firstName },
              attrs: {
                placeholder: "First Name*",
                type: "text",
                tabindex: "1",
                required: "",
                autofocus: "",
              },
              domProps: { value: _vm.patient.firstName },
              on: {
                focus: function ($event) {
                  _vm.validate.firstName = true
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.patient, "firstName", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("fieldset", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.patient.lastName,
                  expression: "patient.lastName",
                },
              ],
              class: { error: !_vm.validate.lastName },
              attrs: {
                placeholder: "Last Name*",
                type: "text",
                tabindex: "2",
                required: "",
              },
              domProps: { value: _vm.patient.lastName },
              on: {
                focus: function ($event) {
                  _vm.validate.lastName = true
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.patient, "lastName", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("fieldset", [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.patient.emailAddress,
                  expression: "patient.emailAddress",
                },
              ],
              class: { error: !_vm.validate.emailAddress },
              attrs: {
                placeholder: "Email Address*",
                type: "email",
                tabindex: "3",
                required: "",
              },
              domProps: { value: _vm.patient.emailAddress },
              on: {
                focus: function ($event) {
                  _vm.validate.emailAddress = true
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.patient, "emailAddress", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("fieldset", [
            _c("input", {
              directives: [
                {
                  name: "mask",
                  rawName: "v-mask",
                  value: "(###) ###-####",
                  expression: "'(###) ###-####'",
                },
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.patient.phoneNumber,
                  expression: "patient.phoneNumber",
                },
              ],
              class: { error: !_vm.validate.phoneNumber },
              attrs: {
                placeholder: "Phone Number*",
                type: "tel",
                tabindex: "4",
                required: "",
              },
              domProps: { value: _vm.patient.phoneNumber },
              on: {
                focus: function ($event) {
                  _vm.validate.phoneNumber = true
                },
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.patient, "phoneNumber", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("fieldset", { staticClass: "radios mt-4" }, [
            _c("label", { staticClass: "title" }, [
              _vm._v("Bringing Familiar Voice?"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "radio-selector",
                class: { error: !_vm.validate.bringingFamiliarVoice },
              },
              [
                _c("div", { staticClass: "radio-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.patient.bringingFamiliarVoice,
                        expression: "patient.bringingFamiliarVoice",
                      },
                    ],
                    staticClass: "radio-group__input",
                    attrs: {
                      id: "familiarVoiceTrue",
                      name: "familiarVoice",
                      type: "radio",
                      tabindex: "5",
                    },
                    domProps: {
                      value: true,
                      checked: _vm._q(_vm.patient.bringingFamiliarVoice, true),
                    },
                    on: {
                      click: function ($event) {
                        _vm.validate.bringingFamiliarVoice = true
                      },
                      change: function ($event) {
                        return _vm.$set(
                          _vm.patient,
                          "bringingFamiliarVoice",
                          true
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "radio-group__text",
                      attrs: { for: "familiarVoiceTrue" },
                    },
                    [_vm._v("Yes")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "radio-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.patient.bringingFamiliarVoice,
                        expression: "patient.bringingFamiliarVoice",
                      },
                    ],
                    staticClass: "radio-group__input",
                    attrs: {
                      id: "familiarVoiceFalse",
                      name: "familiarVoice",
                      type: "radio",
                      tabindex: "6",
                    },
                    domProps: {
                      value: false,
                      checked: _vm._q(_vm.patient.bringingFamiliarVoice, false),
                    },
                    on: {
                      click: function ($event) {
                        _vm.validate.bringingFamiliarVoice = true
                      },
                      change: function ($event) {
                        return _vm.$set(
                          _vm.patient,
                          "bringingFamiliarVoice",
                          false
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "radio-group__text",
                      attrs: { for: "familiarVoiceFalse" },
                    },
                    [_vm._v("No")]
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.patient.bringingFamiliarVoice
            ? [
                _c("fieldset", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.patient.familiarVoiceFirstName,
                        expression: "patient.familiarVoiceFirstName",
                      },
                    ],
                    class: { error: !_vm.validate.familiarVoiceFirstName },
                    attrs: {
                      placeholder: "Familiar Voice First Name*",
                      type: "text",
                      tabindex: "7",
                      required: "",
                    },
                    domProps: { value: _vm.patient.familiarVoiceFirstName },
                    on: {
                      focus: function ($event) {
                        _vm.validate.familiarVoiceFirstName = true
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.patient,
                          "familiarVoiceFirstName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.patient.familiarVoiceLastName,
                        expression: "patient.familiarVoiceLastName",
                      },
                    ],
                    class: { error: !_vm.validate.familiarVoiceLastName },
                    attrs: {
                      placeholder: "Familiar Voice Last Name*",
                      type: "text",
                      tabindex: "8",
                      required: "",
                    },
                    domProps: { value: _vm.patient.familiarVoiceLastName },
                    on: {
                      focus: function ($event) {
                        _vm.validate.familiarVoiceLastName = true
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.patient,
                          "familiarVoiceLastName",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("fieldset", [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.patient.relation,
                          expression: "patient.relation",
                        },
                      ],
                      class: { error: !_vm.validate.relation },
                      attrs: { tabindex: "9", required: "" },
                      on: {
                        focus: function ($event) {
                          _vm.validate.relation = true
                        },
                        change: function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.$set(
                            _vm.patient,
                            "relation",
                            $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          )
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        { attrs: { value: "", disabled: "", selected: "" } },
                        [_vm._v("Relation")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.companionTypes, function (item) {
                        return _c("option", { domProps: { value: item } }, [
                          _vm._v(" " + _vm._s(item.name)),
                        ])
                      }),
                    ],
                    2
                  ),
                ]),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("fieldset", { staticClass: "checkbox mt-4" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.accept,
                  expression: "accept",
                },
              ],
              attrs: { type: "checkbox", id: "agreement" },
              domProps: {
                checked: Array.isArray(_vm.accept)
                  ? _vm._i(_vm.accept, null) > -1
                  : _vm.accept,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.accept,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.accept = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.accept = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.accept = $$c
                  }
                },
              },
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "agreement" } }, [
              _vm._v(
                "By checking this box I agree to I agree to receive SMS from Beltone Alliance. Standard text messaging rates apply.  I can opt out at any time. "
              ),
            ]),
          ]),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer-actions" }, [
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          on: {
            click: function ($event) {
              return _vm.prevStep()
            },
          },
        },
        [_vm._v("Back")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-beltone xl",
          class: { disabled: !_vm.accept },
          on: {
            click: function ($event) {
              return _vm.nextStep()
            },
          },
        },
        [_vm._v("Continue")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "radio-group__label",
        attrs: { for: "familiarVoiceTrue" },
      },
      [_c("div", { staticClass: "radio-group__label-filament" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      {
        staticClass: "radio-group__label",
        attrs: { for: "familiarVoiceFalse" },
      },
      [_c("div", { staticClass: "radio-group__label-filament" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }